export default "__VITE_ASSET__DLM99hqL__"